// SEO-Standorte & Leistungen für dynamische Landingpages

export const SERVICES = {
  strom: {
    slug: "strom",
    label: "Stromberatung",
    short: "Strom",
    kw: "Stromtarif",
    intro: (c, s) =>
      `Sie zahlen in ${c} zu viel für Strom? Wir prüfen Ihren Stromtarif kostenlos und unabhängig und finden über börsennahe Beschaffung den passenden Anbieter – für Privathaushalte und Gewerbe in ${c} und ganz ${s}.`,
    benefits: [
      "Unabhängiger Stromvergleich – kein Vergleichsportal",
      "Börsennahe Beschaffung mit oft deutlichem Sparpotenzial",
      "Kompletter Wechselservice inkl. Kündigung",
      "Persönliche Beraterin statt Callcenter",
    ],
  },
  gas: {
    slug: "gas",
    label: "Gasberatung",
    short: "Gas",
    kw: "Gastarif",
    intro: (c, s) =>
      `Gaspreise schwanken stark – wir prüfen Ihren Gasvertrag in ${c} kostenlos, bewerten Laufzeiten und Preisgarantien und sichern günstige Konditionen zum richtigen Zeitpunkt. Für Haushalte und Betriebe in ${c} (${s}).`,
    benefits: [
      "Unabhängiger Gasvergleich für ${c}",
      "Optimales Timing der Beschaffung",
      "Transparente Laufzeiten & Preisgarantien",
      "Rundum-Wechselservice inklusive",
    ],
  },
  gewerbestrom: {
    slug: "gewerbestrom",
    label: "Gewerbestrom",
    short: "Gewerbestrom",
    kw: "Gewerbestromtarif",
    intro: (c, s) =>
      `Für Unternehmen in ${c} optimieren wir Gewerbestrom transparent – ob SLP oder RLM, ob einzelne Betriebsstätte oder mehrere Zählpunkte. Wir bündeln Ihre Standorte in ${s} und beschaffen börsennah.`,
    benefits: [
      "SLP- & RLM-Analyse für Betriebe",
      "Bündelung mehrerer Zählpunkte",
      "Börsennahe Beschaffung ohne Portalprovision",
      "Ideal für Handwerk, Filialisten & Industrie",
    ],
  },
  photovoltaik: {
    slug: "photovoltaik",
    label: "Photovoltaik-Beratung",
    short: "Photovoltaik",
    kw: "PV-Tarif",
    intro: (c, s) =>
      `Sie haben eine PV-Anlage in ${c} oder planen eine? Wir beraten unabhängig zu Reststromtarif, Einspeisung und der Kombination mit Speicher und Wärmepumpe – neutral und ohne Anlagenverkäufer-Interessen.`,
    benefits: [
      "Reststromtarif für ${c} optimieren",
      "Einspeisung & Vermarktung verständlich erklärt",
      "Kombination mit Speicher & Wärmepumpe",
      "100 % unabhängige Empfehlung",
    ],
  },
  waermepumpe: {
    slug: "waermepumpe",
    label: "Wärmepumpen-Stromtarif",
    short: "Wärmepumpe",
    kw: "Wärmepumpentarif",
    intro: (c, s) =>
      `Für Wärmepumpen gibt es in ${c} spezielle, oft günstigere Stromtarife. Wir prüfen, ob ein separater Zähler oder ein Kombitarif sinnvoller ist, und sichern reduzierte Netzentgelte nach §14a EnWG.`,
    benefits: [
      "Spezielle Wärmepumpentarife",
      "Netzentgelt-Vorteile nach §14a EnWG",
      "Kombination mit PV-Eigenstrom",
      "Ehrliche Wirtschaftlichkeitsrechnung",
    ],
  },
};

export const SERVICE_LIST = Object.values(SERVICES);

export const CITIES = [
  { slug: "hamburg", name: "Hamburg", state: "Hamburg" },
  { slug: "berlin", name: "Berlin", state: "Berlin" },
  { slug: "muenchen", name: "München", state: "Bayern" },
  { slug: "nuernberg", name: "Nürnberg", state: "Bayern" },
  { slug: "augsburg", name: "Augsburg", state: "Bayern" },
  { slug: "regensburg", name: "Regensburg", state: "Bayern" },
  { slug: "wuerzburg", name: "Würzburg", state: "Bayern" },
  { slug: "koeln", name: "Köln", state: "Nordrhein-Westfalen" },
  { slug: "duesseldorf", name: "Düsseldorf", state: "Nordrhein-Westfalen" },
  { slug: "dortmund", name: "Dortmund", state: "Nordrhein-Westfalen" },
  { slug: "essen", name: "Essen", state: "Nordrhein-Westfalen" },
  { slug: "duisburg", name: "Duisburg", state: "Nordrhein-Westfalen" },
  { slug: "bochum", name: "Bochum", state: "Nordrhein-Westfalen" },
  { slug: "bonn", name: "Bonn", state: "Nordrhein-Westfalen" },
  { slug: "muenster", name: "Münster", state: "Nordrhein-Westfalen" },
  { slug: "bielefeld", name: "Bielefeld", state: "Nordrhein-Westfalen" },
  { slug: "wuppertal", name: "Wuppertal", state: "Nordrhein-Westfalen" },
  { slug: "aachen", name: "Aachen", state: "Nordrhein-Westfalen" },
  { slug: "frankfurt", name: "Frankfurt am Main", state: "Hessen" },
  { slug: "wiesbaden", name: "Wiesbaden", state: "Hessen" },
  { slug: "kassel", name: "Kassel", state: "Hessen" },
  { slug: "darmstadt", name: "Darmstadt", state: "Hessen" },
  { slug: "stuttgart", name: "Stuttgart", state: "Baden-Württemberg" },
  { slug: "karlsruhe", name: "Karlsruhe", state: "Baden-Württemberg" },
  { slug: "mannheim", name: "Mannheim", state: "Baden-Württemberg" },
  { slug: "freiburg", name: "Freiburg", state: "Baden-Württemberg" },
  { slug: "heidelberg", name: "Heidelberg", state: "Baden-Württemberg" },
  { slug: "hannover", name: "Hannover", state: "Niedersachsen" },
  { slug: "braunschweig", name: "Braunschweig", state: "Niedersachsen" },
  { slug: "osnabrueck", name: "Osnabrück", state: "Niedersachsen" },
  { slug: "oldenburg", name: "Oldenburg", state: "Niedersachsen" },
  { slug: "bremen", name: "Bremen", state: "Bremen" },
  { slug: "dresden", name: "Dresden", state: "Sachsen" },
  { slug: "leipzig", name: "Leipzig", state: "Sachsen" },
  { slug: "chemnitz", name: "Chemnitz", state: "Sachsen" },
  { slug: "magdeburg", name: "Magdeburg", state: "Sachsen-Anhalt" },
  { slug: "halle", name: "Halle (Saale)", state: "Sachsen-Anhalt" },
  { slug: "erfurt", name: "Erfurt", state: "Thüringen" },
  { slug: "jena", name: "Jena", state: "Thüringen" },
  { slug: "kiel", name: "Kiel", state: "Schleswig-Holstein" },
  { slug: "luebeck", name: "Lübeck", state: "Schleswig-Holstein" },
  { slug: "rostock", name: "Rostock", state: "Mecklenburg-Vorpommern" },
  { slug: "schwerin", name: "Schwerin", state: "Mecklenburg-Vorpommern" },
  { slug: "potsdam", name: "Potsdam", state: "Brandenburg" },
  { slug: "mainz", name: "Mainz", state: "Rheinland-Pfalz" },
  { slug: "ludwigshafen", name: "Ludwigshafen", state: "Rheinland-Pfalz" },
  { slug: "koblenz", name: "Koblenz", state: "Rheinland-Pfalz" },
  { slug: "saarbruecken", name: "Saarbrücken", state: "Saarland" },
];

export const getCity = (slug) => CITIES.find((c) => c.slug === slug);
export const getService = (slug) => SERVICES[slug];

export const citiesByState = () => {
  const map = {};
  CITIES.forEach((c) => {
    (map[c.state] = map[c.state] || []).push(c);
  });
  return Object.entries(map).sort((a, b) => a[0].localeCompare(b[0], "de"));
};

// interpolate ${c} placeholders in benefit strings
export const fillBenefit = (text, cityName) => text.replace(/\$\{c\}/g, cityName);
